import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m24.453 8.95-2.44-2.439c-2.06-2.06-3.09-3.091-4.428-3.474-1.336-.384-2.756-.056-5.596.6l-1.638.377c-2.389.551-3.583.827-4.401 1.645S4.856 7.671 4.305 10.06l-.378 1.638c-.655 2.84-.983 4.26-.6 5.596.384 1.337 1.414 2.367 3.475 4.428l2.44 2.44c3.585 3.585 5.377 5.378 7.605 5.378s4.02-1.793 7.606-5.378c3.585-3.586 5.378-5.378 5.378-7.606s-1.793-4.02-5.378-7.605",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.366 19.31c-.898-.897-.89-2.184-.353-3.204a1 1 0 0 1 1.386-1.394c.453-.24.951-.368 1.447-.364a1 1 0 0 1-.019 2c-.236-.002-.546.104-.811.37-.517.517-.381 1.033-.236 1.178s.662.281 1.178-.235c1.046-1.046 2.85-1.393 4.007-.236.898.897.89 2.185.354 3.205a1 1 0 0 1-1.387 1.393c-.61.324-1.302.446-1.963.31a1 1 0 0 1 .402-1.96c.237.05.617-.028.945-.355.516-.517.38-1.034.235-1.179s-.662-.28-1.178.236c-1.046 1.045-2.85 1.392-4.007.236M13.865 13.93a2.667 2.667 0 1 0-3.771-3.771 2.667 2.667 0 0 0 3.77 3.771"
    }, null, -1)
  ])))
}
export default { render: render }